import React, { useState } from 'react';
import PerfumeCard from '../components/PerfumeCard';
import { NATURAL } from '../data/perfumes';
import naturalBanner from '../images/essential_oil/natural_oil.png';

export default function NaturalCollection() {
  const [hoveredId, setHoveredId] = useState(null);
  const [query, setQuery] = useState('');

  const normalized = q => q.trim().toLowerCase();
  const filtered = NATURAL.filter(item => {
    const q = normalized(query);
    if (!q) return true;
    return (
      item.name.toLowerCase().includes(q) ||
      (item.description && item.description.toLowerCase().includes(q))
    );
  });

  return (
    <div className="container app-content" style={{ paddingTop: 12 }}>
      <div style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 24px rgba(15,23,42,0.06)' }}>
        <img src={naturalBanner} alt="Natural collection banner" style={{ width: '100%', height: 260, objectFit: 'cover', display: 'block' }} />
      </div>

      <h2 className="page-title" style={{ marginTop: 18 }}>Natural Collection</h2>
      <p className="page-sub">Unveil the ultimate collection of nature's authentic, untainted aromas</p>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 14 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            background: '#fff',
            border: '2px solid var(--success)',
            padding: '12px 14px',            // increased container vertical padding for taller appearance
            borderRadius: 12,
            boxShadow: '0 6px 18px rgba(15,23,42,0.03)',
            maxWidth: 360,                  // reduced length
            width: '100%',
            height: 56                      // enforce taller search box
          }}
        >
          <input
            aria-label="Search natural collection"
            placeholder="Search natural oils"
            className="input"
            value={query}
            onChange={e => setQuery(e.target.value)}
            style={{
              border: 'none',
              padding: 0,
              outline: 'none',
              width: '100%',
              background: 'transparent',
              height: '100%',                // make input fill taller container
              fontSize: 16
            }}
          />
          {query && (
            <button
              onClick={() => setQuery('')}
              className="btn secondary"
              style={{ padding: '8px 12px', fontWeight: 600, height: '36px' }}
              aria-label="Clear search"
            >
              Clear
            </button>
          )}
        </div>
      </div>

      <div className="collection-grid" role="list">
        {filtered.length === 0 ? (
          <div role="listitem">
            <div className="alert">No matching oils found.</div>
          </div>
        ) : (
          filtered.map(item => (
            <div role="listitem" key={item.id}>
              <PerfumeCard item={item} category="Natural" hoveredId={hoveredId} setHoveredId={setHoveredId} />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
